import { useState } from 'react';
import { token as liveToken } from '../auth/session';
import { serverVoice, speak, stopSpeaking } from '../games/speak';
import { useT } from '../i18n/i18n';

const SAMPLE = 'Find the red car. Well done!';

export default function VoicePreview({ voiceName, rate }: { voiceName: string | null | undefined; rate: number }) {
  const t = useT();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function hear() {
    stopSpeaking();
    setError(null);
    const voice = serverVoice(voiceName);
    if (!voice) {
      void speak(SAMPLE, { voiceName, rate });
      return;
    }
    setBusy(true);
    try {
      const bearer = await liveToken();
      const r = Math.round(rate * 20) / 20;
      const res = await fetch(`/api/speech/preview?v=${voice}&r=${r}`, {
        headers: bearer ? { Authorization: `Bearer ${bearer}` } : {},
        credentials: 'omit',
      });
      if (!res.ok) throw new Error();
      const url = URL.createObjectURL(await res.blob());
      const el = new Audio(url);
      el.onended = () => URL.revokeObjectURL(url);
      await el.play();
    } catch {
      setError(t('This voice could not be played just now. Please try again in a minute.'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <div className="toolbar">
        <button type="button" className="btn secondary" onClick={() => void hear()} disabled={busy}>
          {busy ? t('Preparing the voice…') : t('Hear this voice')}
        </button>
      </div>
      {error && <p className="error" role="alert">{error}</p>}
      <span className="field-hint">
        {t('A new word takes a moment to prepare the first time. A game gets every word ready before it opens, so the voice never changes part-way through.')}
      </span>
      <span className="field-hint">
        {t('Clara, Grace, Oliver, Harriet, Aoede and Achernar are Google Cloud voices. Earlier voices: Kokoro (Apache 2.0). Piper voices Cori (public domain), Alba (University of Edinburgh, CC BY 4.0) and Northern English (OpenSLR 83, CC BY-SA 4.0).')}
      </span>
    </>
  );
}
